document.addEventListener('DOMContentLoaded', () => {
  const checkCompareButtons = () => {
    const buttons = document.querySelectorAll('.sp-compare-button');
    buttons.forEach(btn => {
      // Check if the text contains "Remove" (or similar translation)
      if (btn.textContent.toLowerCase().includes('remove')) {
        btn.classList.add('sp-added');
      } else {
        btn.classList.remove('sp-added');
      }
    });
  };

  // Run immediately in case buttons are already rendered
  checkCompareButtons();

  // Observe the body for dynamic DOM changes (e.g. from Equate app)
  const observer = new MutationObserver((mutations) => {
    let shouldCheck = false;
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        shouldCheck = true;
        break;
      }
      if (mutation.type === 'characterData') {
        shouldCheck = true;
        break;
      }
    }
    
    if (shouldCheck) {
      checkCompareButtons();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
});
